<template>
	<div class="info-cards-inverted">
		<article
			v-for="(card, cardId) in cards"
			:key="cardId"
			:class="[
				'info-card-inverted gap-300-lg gap-150-md p-300 my-300 display-flex-md align-items-center-md',
				{ 'text-color-greige': isDarkTheme },
				{ 'no-border': props.hideBorder }
			]"
		>
			<div :class="['col-6-md mb-300-smo', { 'order-1': isEven(cardId) }]">
				<div v-if="card.heading" :class="['overline mb-100', { 'text-color-gray-20': isDarkTheme }]">
					{{ card.heading }}
				</div>
				<h3 :class="cardHeadingStyle" v-html="card.title"></h3>
				<p v-for="(desc, descId) in card.description" :key="descId" v-html="desc"></p>
				<p v-if="card.link" class="mt-100">
					<BaseCtaLink :link="card.link" :is-orange="isDarkTheme" icon="arrow" />
				</p>
			</div>
			<div v-reveal:fade-up role="figure" class="col-6-md">
				<img :src="cardImgSrc(card.imageUrl)" :alt="card.imageAlt" />
			</div>
		</article>
	</div>
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { InfoCard } from 'types/layout';
interface Props {
	cards: Array<InfoCard>;
	cardHeadingStyle?: Array<string>;
	useFullImgUrl?: boolean;
	theme?: 'light' | 'dark';
	hideBorder?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	cardHeadingStyle: () => ['heading-1'],
	useFullImgUrl: false,
	theme: 'light',
	hideBorder: false
});

const isDarkTheme = computed((): boolean => {
	return props.theme === 'dark';
});

function isEven(index: number): boolean {
	return index % 2 === 0;
}

function cardImgSrc(imageUrl: string): string {
	return props.useFullImgUrl ? imageUrl : appCloudfrontPath + imageUrl;
}
</script>
<style lang="scss" scoped>
@use '../../styles/constants/colors.scss' as *;

.info-card-inverted {
	border: 1px solid token('content-secondary');
	border-radius: 10px;

	&.no-border {
		border-width: 0;
	}
}
</style>
